import request from "./useRequests";
import { userinfo } from '@/stores/counter'

export default function getCarousel() {
  const user = userinfo()
  async function carouseling() {
    try {
      const res = await request({
        method: "get",
        url: `/news/getBanners`,
      })
      const data = res.data.data
      return data;
    } catch (err: any) {
      // console.log
    }
  }

  return {
    carouseling
  }
}